<template>
	<div class="period">
		<messagebox titles='选择部门' width="720px" height="100%" @shut="shut" @sub="sub">
			<div class="boxs">
				<div class="box">
					<div class="search">
						<el-input prefix-icon="el-icon-search" v-model.trim="searchval" style="width: 100%;">
						</el-input>
					</div>
					<div class="nav" v-if="navname.length<4">
						<div class="item" v-for="(v,k) in navname" :key="k">
							<span style="cursor: pointer;" @click="onback(v,k)">{{v.label}}</span>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
					<div class="nav" v-if="navname.length>=4">
						<div class="item">
							<span style="cursor: pointer;" @click="onback(navname[0],0)">{{navname[0].label}}</span>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="item">
							...
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="item">
							<span style="cursor: pointer;" @click="onback(navname[navname.length-1],navname.length-1)">{{navname[navname.length-1].label}}</span>
						</div>
					</div>

					<div class="items">
						<div class="item" v-for="(v,k) in candidate" :key="k">
							<div>
								<input type="checkbox" v-model="determined" :value="{id:v.id,label:v.label}">{{v.label}}
							</div>
							<div @click="onchild(v)" v-if="!onpresence(v.id)">
								<i class="el-icon-share"></i>下级
							</div>
							<div style="color: #AEB1BA;" v-if="onpresence(v.id)">
								<i class="el-icon-share"></i>下级
							</div>
						</div>
					</div>
				</div>
				<div class="box">
					<div class="items">
						<div class="item" v-for="(v,k) in determined">
							<span>
								{{v.label}}
							</span>
							<i class="el-icon-error" style="font-size: 18px; color: #B8B8C4; cursor: pointer;" @click="ondelete(k)"></i>
						</div>
					</div>
				</div>
			</div>
		</messagebox>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				searchval: "",
				original: {},
				candidate: [],
				determined: [],
				navname: [],
			}
		},
		props: {
			width: {
				default: "720px"
			},
			height: {
				default: "450px"
			},
			checkdata: {
				type: Array
			},
		},
		created() {
			this.loadTree()
		},
		
		mounted() {
			this.determined = this.checkdata;
		},
		
		methods: {
			shut() {
				this.$parent.maskshow_department = false
			},
			sub() {
				this.$emit('sub', this.determined)
			},
			loadTree() {
				//封装请求参数
				const params = {
					orgName: ''
				}
				//查询列表的方法
				this.$axios.get('employ/base/tree', {
					params
				}).then(res => {
					//数据初始化
					console.log(res);
					this.original = res.data.data[0];
					this.onchild(res.data.data[0]);
					// 					this.candidate = res.data.data[0].children;
					// 					var obj = {};
					// 					obj.id = res.data.data[0].id;
					// 					obj.label = res.data.data[0].label;
					// 					this.navname.push(obj);
				}).catch(err => {
					//处理错误
					console.error(err)
				})
			},

			onchild(val) {
				this.candidate = val.children;
				this.navname.push(val);
			},

			ondelete(k) {
				this.determined.splice(k, 1);
			},

			onpresence(id) {
				for (var i = 0; i < this.determined.length; i++) {
					if (this.determined[i].id == id) {
						return true;
					}
				}
				return false;
			},

			onback(val, k) {
				this.navname.splice(k, this.navname.length - k);
				this.onchild(val);
			}
		}
	}
</script>

<style scoped lang="less">
	.period /deep/ .messagebox .title {
		border-bottom: none;
	}

	.period /deep/ .el-input__inner {
		height: 30px;
		line-height: 30px;
		font-size: 12px;
	}

	.period /deep/ .el-input__icon {
		line-height: 30px;
	}

	.boxs {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: space-between;
		padding-bottom: 30px;
		box-sizing: border-box;

		.box {
			width: 50%;
			height: 100%;
			background-color: #F2F5F8;
			margin: 0 6px;
			border: 1px solid #D9DBE2;
			border-radius: 6px;
			box-sizing: border-box;
			padding: 16px;
			display: flex;
			flex-direction: column;

			.nav {
				width: 100%;
				margin: 20px 0;
				display: flex;
				align-items: center;

				.item {
					font-size: 14px;

					span {
						color: #6669E3;
					}

					i {
						padding: 0 5px;
					}
				}

				.item:last-child {
					span {
						color: #545566;
					}

					i {
						display: none;
					}
				}
			}

			.items {
				width: 100%;
				height: 100%;
				overflow: auto;

				.item {
					display: flex;
					justify-content: space-between;
					margin-bottom: 15px;
					align-items: center;
					font-size: 14px;

					div {
						display: flex;
						align-items: center;

						input {
							margin-right: 5px;
						}

					}

					div:last-child {
						color: #6069F2;
						cursor: pointer;

						i {
							margin-right: 5px;
						}
					}
				}
			}
		}
	}
</style>
